import React, {Component} from 'react';
import {Jumbotron} from "react-bootstrap";
import LoginForm from "./form/LoginForm";

class LoginJumbotron extends Component {

    render() {
        return (
            <Jumbotron>
                <LoginForm />
            </Jumbotron>
        );
    }
}

export default LoginJumbotron;